/** Created by azhou on 2019/2/22.*/

<template>
    <div>
      <!--酒店基础信息注册-->
      <h-reg-basic v-if="hParamsType" @saveInfo="saveBasicInfo"/>
      <!--采购商的注册基础信息-采购商注册填写企业信息-->
      <t-reg-basic v-if="tParamsType" @saveInfo="saveBasicInfo"/>
    </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import HRegBasic from '../../StoreInfo/BasicInfo/Comps/HRegBasic'
  import TRegBasic from '../../StoreInfo/BasicInfo/Comps/TRegBasic'

  export default {
    name: 'RegBasicType', 
    components: {HRegBasic,TRegBasic},
    computed: {
      ...mapGetters(['storeInfo']),
      //显示酒店、民宿、景区的基础信息
      hParamsType() {
        let t = [3];
        return this.$GFUN.isInArray(t,this.storeInfo.type);
      },
      //显示采购商基础信息
      tParamsType() {
        return this.storeInfo.type === 2;
      }
    },
    methods: {
      ...mapActions(['saveStoreInfo','getStoreInfo']),
      /*保存用户基础信息*/
      saveBasicInfo(info,tabPosition) {
        this.saveStoreInfo({
          ajaxUrl: '/pc/Hotel/EditBaseInfo',
          newInfo: info,
          successFun: () => {
            // this.getStoreInfo();
            switch (this.storeInfo.type) {
              case 2:
                this.$router.push({ name: 'regVerify' }); break;
              case 3:
              case 5:
              case 6:
                if(tabPosition<=3 && tabPosition) return
                this.$router.push({ name: 'regStorePhotos',query:{step:2} }); break;
              default:break;
            }
          }})
      }
    }
  }
</script>
